{
  "dashboard": {
    "welcomeBack": "Welcome back",
    "subtitle": "Your live auction control centre. Track bids, watchlist and payouts in one place.",
    "sellerDashboardBtn": "Seller Dashboard",
    "listCardBtn": "List a card",
    "stat": {
      "leadingLabel": "Leading now",
      "leadingHint": "Live auctions you're winning",
      "outbidLabel": "Outbid",
      "outbidHint": "Live auctions to re-bid on",
      "wonLabel": "Auctions won",
      "wonHint": "Completed wins",
      "watchlistLabel": "Watchlist",
      "watchlistHint": "Cards you're tracking"
    },
    "summary": {
      "pendingPaymentsLabel": "Pending payments",
      "pendingPaymentsHint": "Orders awaiting checkout",
      "totalSpendLabel": "Total spend",
      "totalSpendHint": "Across paid orders",
      "ordersLabel": "Orders",
      "ordersHint": "All-time order records",
      "listingsLabel": "My listings",
      "listingsHint": "Cards you have listed"
    },
    "pendingBanner": "{count, plural, one {You have # order awaiting payment.} other {You have # orders awaiting payment.}}",
    "completePayment": "Complete payment",
    "leadingListTitle": "Auctions you're leading",
    "leadingListEmpty": "You're not the highest bidder on any live auction right now.",
    "outbidListTitle": "You've been outbid",
    "outbidListEmpty": "No outbid auctions — nicely held.",
    "watchlistListTitle": "Watchlist",
    "watchlistListEmpty": "Your watchlist is empty.",
    "viewAll": "View all",
    "quickLink": {
      "sellerTitle": "Seller Dashboard",
      "sellerHint": "Sales, earnings, payouts & performance",
      "myBidsTitle": "My bids",
      "myBidsHint": "Track your activity",
      "watchlistTitle": "Watchlist",
      "watchlistHint": "Cards you're following"
    }
  },
  "sidebar": {
    "buyingGroup": "Buying",
    "dashboard": "Dashboard",
    "browseAuctions": "Browse Auctions",
    "watchlist": "Watchlist",
    "myBids": "My Bids",
    "wonOrders": "Won & Orders",
    "sellingGroup": "Selling",
    "sellerDashboard": "Seller Dashboard",
    "myAuctions": "My Auctions",
    "listCard": "List a Card",
    "payouts": "Payouts",
    "accountGroup": "Account",
    "notifications": "Notifications",
    "settings": "Settings",
    "adminGroup": "Admin",
    "admin": "Admin",
    "signOut": "Sign out"
  },
  "billing": {
    "eyebrow": "Seller",
    "title": "Fees & Payouts",
    "subtitle": "BidNova charges a simple 8% commission on successful sales only. No monthly fees. No subscription fees. No listing fees.",
    "included": {
      "noListingFees": "No listing fees",
      "noMonthlyFees": "No monthly fees",
      "noSubscriptionFees": "No subscription fees",
      "commissionOnly": "Commission only on successful sales",
      "securePayouts": "Secure Stripe payouts in GBP",
      "buyerProtection": "Buyer protection & dispute handling included"
    },
    "commissionTitle": "Seller commission",
    "commissionBadge": "Flat 8%",
    "commissionDesc": "Charged only when your item sells.",
    "howTitle": "How payouts are calculated",
    "howDesc": "Transparent, itemised on every order.",
    "formula": "Seller Payout = Final Sale Price − 8% BidNova Commission",
    "bullet1": "Buyers pay the full winning bid plus any shipping you set.",
    "bullet2": "BidNova deducts an 8% commission from the item total (not from shipping).",
    "bullet3": "The remaining balance is paid out to your connected Stripe account after delivery is confirmed and any dispute window has passed.",
    "bullet4": "Stripe payment processing fees may apply and are shown on each order.",
    "exampleTitle": "Example",
    "exampleFinalPrice": "Final sale price",
    "exampleCommission": "BidNova commission (8%)",
    "examplePayout": "Seller payout"
  },
  "scanHistory": {
    "eyebrow": "AI Scanner",
    "title": "Scan history",
    "subtitle": "Every scan you've run, with the recognised card, confidence, condition suggestion and any authenticity notes.",
    "newListing": "New listing",
    "loading": "Loading…",
    "empty": "No scans yet. Start a listing to scan your first card with AI.",
    "conditionFallback": "Condition —",
    "verifyBadge": "Verify",
    "confirmedBadge": "Confirmed",
    "deleteConfirm": "Delete this scan? This can't be undone.",
    "deleteSuccess": "Scan deleted",
    "duplicateBtn": "Duplicate"
  },
  "shipping": {
    "backToSeller": "Back to Seller Dashboard",
    "eyebrow": "Shipping",
    "title": "Shipping preferences",
    "subtitle": "Manage your preferred shipping options for BidNova listings. You do not need to connect Royal Mail to sell on BidNova.",
    "loading": "Loading your shipping preferences…",
    "prefsHeading": "Your shipping preferences",
    "prefsDesc": "Set the default parcel and service used when you create a new listing.",
    "noteOptional": "Royal Mail Click & Drop is optional. Sellers may choose any supported shipping service when publishing a listing.",
    "preferredService": "Preferred shipping service",
    "preferredServiceHelp": "Used as the default on new listings. You can override this per listing.",
    "defaultWeight": "Default parcel weight (grams)",
    "defaultFormat": "Default package type",
    "futureHeading": "More preferences coming soon",
    "futureDispatch": "Dispatch time (how quickly you post after a sale)",
    "futureDomestic": "Domestic shipping preference",
    "futureCollection": "Collection preference",
    "futureNote": "These options aren't available yet. Set your dispatch expectations in each listing description for now.",
    "senderHeading": "Sender / return details",
    "senderDesc": "Used on shipping labels and return addresses when applicable.",
    "senderName": "Trading / sender name",
    "senderEmail": "Contact email",
    "senderPhone": "Contact phone",
    "senderLine1": "Address line 1",
    "senderLine2": "Address line 2",
    "senderCity": "City",
    "senderCounty": "County",
    "senderPostcode": "Postcode",
    "senderCountry": "Country",
    "savePreferences": "Save preferences",
    "saveSuccess": "Shipping preferences saved",
    "saveError": "We couldn't save your shipping preferences. Please try again.",
    "advancedHeading": "Advanced shipping integrations",
    "advancedDesc": "Optional. Connect a third-party postage account for integrated label creation.",
    "royalMailTitle": "Royal Mail Click & Drop",
    "royalMailDesc": "Connect your Royal Mail Click & Drop account to generate shipping labels directly from BidNova. Shipping labels are billed directly to your Royal Mail account. BidNova does not charge or store Royal Mail postage fees.",
    "royalMailOptionalNote": "This integration is optional and intended for sellers who already use Royal Mail Click & Drop.",
    "statusConnected": "Connected",
    "statusUnsuccessful": "Connection unsuccessful",
    "statusNotConnected": "Not connected",
    "connectedMessage": "Your Royal Mail Click & Drop account is connected.",
    "onFile": "On file",
    "lastChecked": "last checked",
    "testConnection": "Test connection",
    "disconnect": "Disconnect",
    "connectSuccess": "Royal Mail Click & Drop connected",
    "connectErrorTitle": "Connection unsuccessful",
    "connectErrorDesc": "We couldn't verify your Royal Mail Click & Drop account. Please check your API key and try again.",
    "testSuccess": "Royal Mail connection is valid",
    "disconnectSuccess": "Royal Mail disconnected",
    "disconnectError": "We couldn't disconnect Royal Mail. Please try again.",
    "invalidTitle": "Connection unsuccessful",
    "invalidDesc": "We couldn't verify your Royal Mail Click & Drop account. Please check your API key and try again.",
    "notConnectedNote": "You can sell on BidNova without connecting Royal Mail. Connect Click & Drop only if you want integrated label creation.",
    "apiKeyLabel": "Royal Mail Click & Drop API key",
    "apiKeyHelp": "Your API key is encrypted when stored and is never shown in full after saving.",
    "connectVerify": "Connect & verify",
    "connecting": "Connecting…",
    "disconnectDialogTitle": "Disconnect Royal Mail?",
    "disconnectDialogDesc": "Disconnecting will stop BidNova from creating Royal Mail labels. Existing labels and previous orders will not be affected.",
    "cancel": "Cancel"
  },
  "shipped": {
    "eyebrow": "Seller",
    "title": "Shipped History",
    "subtitle": "Track past shipments, delivery outcomes and returns. Read-only.",
    "backToDashboard": "Back to dashboard",
    "tabShipped": "Shipped Orders",
    "tabDelivered": "Delivered",
    "tabCancelled": "Cancelled",
    "tabReturned": "Returned",
    "searchPlaceholder": "Search by buyer, auction title or tracking number…",
    "searchAriaLabel": "Search shipped orders",
    "filterBuyer": "Buyer",
    "filterBuyerPlaceholder": "Buyer name",
    "filterTracking": "Tracking #",
    "filterTrackingPlaceholder": "Royal Mail tracking",
    "filterAuction": "Auction",
    "filterAuctionPlaceholder": "Auction title",
    "filterFrom": "From",
    "filterTo": "To",
    "resultsCount": "{count, plural, one {# result} other {# results}}",
    "clearFilters": "Clear filters",
    "refresh": "Refresh",
    "colOrder": "Order",
    "colAuction": "Auction",
    "colBuyer": "Buyer",
    "colTracking": "Tracking",
    "colService": "Service",
    "colRoyalMail": "Royal Mail",
    "colDispatched": "Dispatched",
    "colDelivered": "Delivered",
    "colTotal": "Total",
    "colStatus": "Status",
    "colActions": "Actions",
    "loadError": "Couldn't load shipped history.",
    "retry": "Retry",
    "noMatches": "No matching orders.",
    "pageOf": "Page {page} of {totalPages}",
    "previous": "Previous",
    "next": "Next",
    "viewOrder": "View order",
    "copyTracking": "Copy tracking number",
    "copyTrackingSuccess": "Tracking number copied.",
    "copyTrackingError": "Could not copy tracking number.",
    "downloadLabel": "Download shipping label",
    "labelUnavailable": "Label unavailable.",
    "trackAria": "Track {tracking} on Royal Mail",
    "statusLabelCreated": "Label Created",
    "statusDispatched": "Dispatched",
    "statusInTransit": "In Transit",
    "statusDelivered": "Delivered",
    "statusDeliveryAttempted": "Delivery Attempted",
    "statusCancelled": "Cancelled",
    "statusReturned": "Returned",
    "orderStatusShipped": "Shipped",
    "orderStatusDelivered": "Delivered",
    "orderStatusReleased": "Completed",
    "orderStatusCancelled": "Cancelled",
    "orderStatusRefunded": "Refunded"
  },
  "sellerIndex": {
    "eyebrow": "Seller",
    "title": "Dashboard",
    "subtitle": "Manage your listings, sales, payouts and performance in one place.",
    "shippedHistoryBtn": "Shipped history",
    "shippingSettingsBtn": "Shipping settings",
    "tabOverview": "Overview",
    "tabStripe": "Stripe",
    "tabAuctions": "Auctions",
    "tabFulfilment": "Fulfilment",
    "tabSales": "Sales",
    "tabEarnings": "Earnings",
    "tabPerformance": "Performance",
    "tabAnalytics": "Analytics",
    "tabPortfolio": "Portfolio",
    "tabNotifications": "Notifications",
    "kpi": {
      "totalSales": "Total sales",
      "totalSalesHint": "Paid + shipped + delivered + released",
      "auctionRevenue": "Auction revenue",
      "auctionRevenueHint": "Sales from auction wins",
      "binRevenue": "Buy It Now revenue",
      "binRevenueHint": "{count, plural, one {# BIN order} other {# BIN orders}}",
      "binConversionRate": "BIN conversion rate",
      "binConversionHint": "{sold} sold / {listings} listings",
      "binAvgPrice": "BIN average price",
      "binAvgPriceHint": "Avg BIN selling price",
      "activeBinListings": "Active BIN listings",
      "activeBinListingsHint": "Currently available for BIN",
      "expiredBinListings": "Expired BIN listings",
      "expiredBinListingsHint": "BIN-enabled but ended or sold",
      "reservationsExpired": "Reservations expired",
      "reservationsExpiredHint": "BIN checkouts abandoned",
      "netEarnings": "Net earnings",
      "netEarningsHint": "After 8% platform fee",
      "heldBalance": "Held balance",
      "heldBalanceHint": "Awaiting delivery confirmation",
      "availablePayout": "Available for payout",
      "availablePayoutHint": "Released to your Stripe account",
      "platformFees": "Platform fees",
      "activeAuctions": "Active auctions",
      "totalWatchers": "Total watchers",
      "totalWatchersHint": "Across your active auctions",
      "endingSoon": "Ending in 24h",
      "pendingApproval": "Pending approval",
      "pendingApprovalHint": "Awaiting moderator review",
      "rejected": "Rejected",
      "awaitingShipment": "Awaiting shipment",
      "awaitingShipmentHint": "Ready to post",
      "completedOrders": "Completed orders"
    },
    "refresh": "Refresh",
    "monthlySales": "Monthly sales",
    "monthlySalesEmpty": "No sales yet — your first order will appear here.",
    "salesTooltipLabel": "Sales",
    "recentActivity": "Recent activity",
    "recentActivityEmpty": "No activity yet.",
    "stripeAccountTitle": "Stripe Express account",
    "connectedAccount": "Connected account",
    "openExpressDashboard": "Open Stripe Express Dashboard",
    "finishOnboarding": "Finish Stripe onboarding to open your Express dashboard and receive payouts.",
    "yourAuctions": "Your auctions",
    "yourAuctionsDesc": "Manage listings, edit non-bid fields, cancel or relist ended items.",
    "openAuctionsManager": "Open auctions manager",
    "listNewCard": "List a new card",
    "filteredByStatus": "Filtered by status:",
    "clearFilter": "Clear filter",
    "bidLockNote": "Once bids exist on an auction, only description and photos can be edited — price and end time are locked.",
    "colAuction": "Auction",
    "colStatus": "Status",
    "colEnds": "Ends",
    "colBids": "Bids",
    "colWatchers": "Watchers",
    "colHighestBid": "Highest bid",
    "colListed": "Listed",
    "sortByAria": "Sort by {label}",
    "loading": "Loading…",
    "noListings": "No listings yet.",
    "ended": "Ended",
    "salesShipping": "Sales & shipping",
    "salesShippingDesc": "Full order pipeline: paid → ready → exported to Click & Drop → shipped → delivered → payout released. Bulk CSV export, mark-as-shipped with tracking, and Royal Mail links are all in the orders workspace.",
    "openOrdersWorkspace": "Open orders workspace",
    "salesPipeline": "Sales pipeline",
    "salesPipelineDesc": "Click any stage to view matching orders in the orders workspace.",
    "stageAwaitingPayment": "Awaiting Payment",
    "stagePaid": "Paid",
    "stageReadyToShip": "Ready to Ship",
    "stageShipped": "Shipped",
    "stageDelivered": "Delivered",
    "stageReleased": "Released",
    "tileGrossSales": "Gross sales",
    "tilePlatformFees": "Platform fees",
    "tileShippingReceived": "Shipping received",
    "tileRefunds": "Refunds",
    "tileNetEarnings": "Net earnings",
    "tileHeldBalance": "Held balance",
    "tileReleasedPayout": "Released to payout",
    "tileActiveDisputes": "Active disputes",
    "nextExpectedPayout": "Next expected payout",
    "ordersPendingRelease": "{count, plural, one {# order pending release} other {# orders pending release}}",
    "showingPendingHint": "Showing pending payouts — click to show released",
    "clickToViewIncluded": "Click to view included orders",
    "pendingPayoutsTitle": "Pending payouts",
    "payoutHistoryTitle": "Payout history",
    "downloadCsv": "Download CSV statement",
    "noPendingPayouts": "No pending payouts.",
    "noReleasedPayouts": "No payouts released yet.",
    "colOrderDate": "Order date",
    "colDate": "Date",
    "colAmount": "Amount",
    "colReference": "Reference",
    "csvOrder": "Order",
    "csvAuction": "Auction",
    "csvDate": "Date",
    "csvStatus": "Status",
    "csvGross": "Gross",
    "csvFee": "Fee",
    "csvShipping": "Shipping",
    "csvNet": "Net",
    "csvReleased": "Released",
    "csvReference": "Reference",
    "sellerStatus": "Seller status",
    "perfCompletedSales": "Completed sales",
    "perfCancellationRate": "Cancellation rate",
    "perfLateShipments": "Late shipments (>72h)",
    "perfAvgDispatch": "Avg dispatch time",
    "perfDeliveryConfirmed": "Delivery confirmed",
    "perfOpenDisputes": "Open disputes",
    "perfAccountWarnings": "Account warnings",
    "feedbackNote": "Feedback score — buyer feedback is coming soon. Your dispatch speed and delivery-confirmation rate above already drive your seller reputation.",
    "sellerNotifications": "Seller notifications",
    "markAllRead": "Mark all as read",
    "allCaughtUp": "You're all caught up.",
    "somethingWrong": "Something went wrong",
    "retry": "Retry"
  },
  "profile": {
    "eyebrow": "Account",
    "title": "Account & Profile",
    "subtitle": "Your login email remains private and is never shown on your public seller profile.",
    "privateHeading": "Private account details",
    "privateDesc": "Only visible to you. Never shown on public pages.",
    "loginEmail": "Login email",
    "emailVerified": "Email verified",
    "verifiedYes": "Yes",
    "verifiedNo": "Not yet verified",
    "changePassword": "Change password",
    "publicHeading": "Public profile",
    "avatarLabel": "Avatar or shop logo",
    "avatarHelp": "JPG, PNG, or WebP · up to 5 MB.",
    "uploading": "Uploading…",
    "uploadImage": "Upload image",
    "remove": "Remove",
    "displayName": "Display name",
    "displayNameHelp": "Your public personal or community name.",
    "username": "Username",
    "usernameHelp": "3–30 chars, lowercase letters, numbers, hyphens. Used in your public URL:",
    "usernameChangeNote": "Username can be changed once every 30 days.",
    "checkingAvailability": "Checking availability…",
    "usernameCurrent": "This is your current username.",
    "usernameAvailable": "This username is available.",
    "shopName": "Shop name",
    "shopNamePlaceholder": "Optional — e.g. Double Blessings TCG",
    "shopNameHelp": "Shown to buyers instead of your display name when set.",
    "bio": "Bio",
    "bioPlaceholder": "A short public introduction. Plain text only.",
    "location": "Public location",
    "locationPlaceholder": "e.g. Manchester, United Kingdom",
    "locationHelp": "Do not enter your full home address. This information may be visible publicly.",
    "coverImage": "Cover image",
    "coverImageHelp": "Wide banner shown at the top of your public seller page. JPG, PNG, or WebP · up to 5 MB.",
    "noCoverImage": "No cover image yet",
    "uploadCover": "Upload cover",
    "replaceCover": "Replace cover",
    "website": "Website",
    "socialTwitter": "Twitter / X",
    "socialInstagram": "Instagram",
    "socialFacebook": "Facebook",
    "socialYoutube": "YouTube",
    "socialTiktok": "TikTok",
    "socialDiscord": "Discord",
    "publicSellerProfile": "Public seller profile",
    "publicSellerProfileDesc": "When on, buyers can visit your seller page at",
    "publicPreview": "Public preview",
    "saving": "Saving…",
    "saveProfile": "Save profile",
    "toastProfileUpdated": "Your public profile has been updated.",
    "toastSaveFailed": "Could not save profile.",
    "toastInvalidImage": "Please choose a JPG, PNG, or WebP image.",
    "toastImageTooLarge": "Image must be 5 MB or smaller.",
    "toastCoverReady": "Cover ready. Save your profile to publish it.",
    "toastUploadFailed": "Upload failed.",
    "toastAvatarReady": "Avatar ready. Save your profile to publish it."
  }
}
